import { Typography, VStack } from '@vivaahealth/design-system';

interface HeaderProps {
  header: string;
  subheader: string;
  customContent?: string;
}

const Heading = ({ header, subheader, customContent }: HeaderProps) => {
  return (
    <VStack gap={12}>
      <Typography variant="headline-small" bold>
        {header}
      </Typography>
      <Typography variant="paragraph-large">{subheader}</Typography>
      {customContent && (
        <Typography variant="paragraph-large">{customContent}</Typography>
      )}
    </VStack>
  );
};

export default Heading;
